module.exports = __webpack_public_path__ + "img/794-fe82c6.png";